module.exports = __webpack_public_path__ + "static/media/Electrical-wiring.4eda5ec2.jpg";